import UnreviewedCheckinDetails from './UnreviewedCheckinDetails.component';

export default UnreviewedCheckinDetails;
